import { Box } from "@mui/system";
import { PrimaryButton, OutlinedPrimaryButton } from "../Button";
import { DialogBox, DialogBoxContent } from "../DialogBox";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmDialogProps {
  heading: string;
  subHeading: string;
  open: boolean;
  onClose: () => void;
  onOk: () => void;
}

const ConfirmationModal = ({
  open,
  onClose,
  onOk,
  heading,
  subHeading,
}: ConfirmDialogProps) => {
  return (
    <DialogBox
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box display="flex" alignItems="center">
        <Typography
          sx={{
            fontSize: "18px",
            fontFamily: "Jost",
            color: "#000",
            paddingLeft: "12px",
          }}
        >
          {heading}
        </Typography>
      </Box>
      <IconButton
        aria-label="close"
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <DialogBoxContent>
        <Box
          sx={{
            display: "block",
            flexDirection: "column",
            justifyContent: "left",
            textAlign: "left",
            paddingLeft: "12px",
            gap: "24px",
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: "14px", fontFamily: "Jost", marginBottom: "12px" }}
            >
              {subHeading}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <OutlinedPrimaryButton onClick={onClose} sx={{ minWidth: "60px" }}>
            No
          </OutlinedPrimaryButton>
          <PrimaryButton onClick={onOk} sx={{ minWidth: "60px" }}>
            Yes
          </PrimaryButton>
        </Box>
      </DialogBoxContent>
    </DialogBox>
  );
};
export default ConfirmationModal;
